var React = require('react');

function Cart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.6 21.7l-2.3-15c-.2-1-1-1.7-2-1.7H17c0-2.8-2.2-5-5-5S7 2.2 7 5H4.7c-1 0-1.8.7-2 1.7l-2.4 15c-.2 1.2.7 2.3 2 2.3h19.3c1.2 0 2.2-1.1 2-2.3zM12 2c1.7 0 3 1.3 3 3H9c0-1.7 1.3-3 3-3zm9.1 20H2.9c-.3 0-.5-.3-.5-.6l2.2-14c.1-.2.3-.4.5-.4H7v2c0 .6.4 1 1 1s1-.4 1-1V7h6v2c0 .6.4 1 1 1s1-.4 1-1V7h1.9c.2 0 .5.2.5.4l2.2 14c0 .3-.2.6-.5.6z"}));
}

Cart.defaultProps = {"width":"24","height":"24"};

module.exports = Cart;

Cart.default = Cart;
